<template>
    <v-container>
        <v-layout>
            <v-expansion-panel>
                <v-expansion-panel-content v-for="(topic, index) in topics" :key="index">
                    <div slot="header">{{topic.description}}</div>
                    <v-card>
                        <v-card-text>{{topic.details}}</v-card-text>
                    </v-card>
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    data() {
        return {
            topics: [
                {
                    description: 'Ny leveranse',
                    details: 'Klikk på NY LEVERANSE knapp'
                },
                {
                    description: 'Ny leveranse'
                }
            ]
        }
    },
    beforeRouteEnter(to, from, next) {
        next(vue => {
            vue.$store.commit("showAppBar", true);
            vue.$store.commit("showNavDrawer", true);
        });
    },
}
</script>

<style lang="scss" scoped>

</style>
